import type { NubeSDKRuntime } from "@tiendanube/nube-sdk-internal-types";

type QueueItem = [keyof NubeSDKRuntime, ...args: unknown[]];

export function sortQueue(a: QueueItem, b: QueueItem): -1 | 0 | 1 {
	if (a[0] === "on" && b[0] !== "on") return -1;
	if (a[0] !== "on" && b[0] === "on") return 1;
	return 0;
}
